/* eslint-disable @typescript-eslint/no-explicit-any */
import { AxiosResponse } from 'axios';
import { InfoNotification } from '../../../app.notification';
import { AxiosErrorResponse } from '../../../app.settings';

import api from '../../../axios';
import { ILotacao } from './model';

export async function getById(regId: string): Promise<ILotacao | any> {
  try {
    const { data } = await api.get<AxiosResponse<ILotacao>>('/lotacao/' + regId);
    return data as unknown as ILotacao;
  } catch (error: any) {
    AxiosErrorResponse(error);
  }
}
export async function getAll(): Promise<ILotacao[] | undefined> {
  try {
    const { data } = await api.get<AxiosResponse<ILotacao[]>>('/lotacao');
    return data as unknown as ILotacao[];
  } catch (error: any) {
    AxiosErrorResponse(error);
  }
}

export async function update(reg: Partial<ILotacao>): Promise<ILotacao | any> {
  try {
    const { data } = await api.put<AxiosResponse<ILotacao>>('/lotacao/' + reg.id, {
      ...reg,
    });
    return (data as unknown as ILotacao[])[0];
  } catch (error: any) {
    AxiosErrorResponse(error);
  }
}

export async function insert(reg: ILotacao): Promise<ILotacao | any> {
  try {
    const { data } = await api.post<AxiosResponse<ILotacao>>('/lotacao/', {
      ...reg,
    });
    return (data as unknown as ILotacao[])[0];
  } catch (error: any) {
    AxiosErrorResponse(error);
  }
}

export async function save(reg: ILotacao): Promise<ILotacao | any> {
  try {
    if (reg.id) {
      return await update(reg).then(() => {
        InfoNotification('Registro alterado!');
      });
    } else {
      return await insert(reg).then(() => {
        InfoNotification('Registro criado!');
      });
    }
  } catch (error: any) {
    AxiosErrorResponse(error);
  }
}

export async function remove(regId: string): Promise<ILotacao | any> {
  try {
    return await api.delete<AxiosResponse<ILotacao>>('/lotacao/' + regId).then(() => {
      InfoNotification('Registro excluido!');
    });
  } catch (error: any) {
    AxiosErrorResponse(error);
  }
}
